import React from "react";
import { useSelector } from "react-redux";
import male from "../../assets/images/male.png";
import userIcon from "../../assets/images/user.png";
import phoneIcon from "../../assets/images/phone.png";
import useTranslation from "../../hooks/useTranslation";
import { T, glassCard } from "../../util/theme";

const Accepted = () => {
  const { t } = useTranslation();
  const { request } = useSelector((state) => state.hostRequest);

  const fmtDate = (d) =>
    (d ? new Date(d) : new Date())
      .toLocaleDateString("en-GB")
      .replace(/\//g, "-");

  return (
    <>
      {request?.length > 0 ? (
        <div className="accepted-list" style={{ padding: "4px 0" }}>
          {request.map((data, index) => (
            <div
              key={data?._id || index}
              style={{
                ...glassCard,
                padding: 16,
                marginBottom: 12,
              }}
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  gap: 12,
                }}
              >
                <div style={{ display: "flex", gap: 12, flex: 1, minWidth: 0, alignItems: "center" }}>
                  <img
                    src={data?.user?.image || male}
                    alt=""
                    style={{
                      height: 48,
                      width: 48,
                      objectFit: "cover",
                      borderRadius: "50%",
                      flexShrink: 0,
                    }}
                  />
                  <div style={{ minWidth: 0 }}>
                    <div
                      style={{
                        fontWeight: 700,
                        color: "#FFFFFF",
                        fontSize: 14,
                        lineHeight: "20px",
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                      }}
                    >
                      {data?.name || "-"}
                    </div>
                    <div
                      style={{
                        fontSize: 13,
                        color: "#FFFFFFA3",
                        fontWeight: 400,
                        marginTop: 2,
                        lineHeight: "17px",
                      }}
                    >
                      {t("ID")}: {data?.user?.uniqueId || "-"}
                    </div>
                  </div>
                </div>

                <span
                  style={{
                    display: "inline-flex",
                    alignItems: "center",
                    gap: 6,
                    color: "#00E959",
                    fontSize: 13,
                    fontWeight: 500,
                    flexShrink: 0,
                    lineHeight: 1,
                    whiteSpace: "nowrap",
                  }}
                >
                  <span
                    style={{
                      width: 8,
                      height: 8,
                      backgroundColor: "#00E959",
                      borderRadius: "50%",
                      display: "inline-block",
                      flexShrink: 0,
                    }}
                  />
                  {t("accepted", "Accepted")}
                </span>
              </div>

              <div style={{ height: 1, background: "#FFFFFF2B", margin: "14px 0 12px" }} />

              <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
                <DetailRow
                  icon={
                    <img
                      src={userIcon}
                      alt=""
                      width={16}
                      height={16}
                      style={{ objectFit: "contain", display: "block" }}
                    />
                  }
                  label={t("join") || "Joined"}
                  value={fmtDate(data?.updatedAt || data?.createdAt)}
                />
                <DetailRow
                  icon={
                    <img
                      src={phoneIcon}
                      alt=""
                      width={16}
                      height={16}
                      style={{ objectFit: "contain", display: "block" }}
                    />
                  }
                  label={t("mobile")}
                  value={data?.mobile || data?.user?.mobile || "-"}
                />
              </div>
            </div>
          ))}
        </div>
      ) : (
        <EmptyState title={t("no_accept")} subtitle={t("no_accepted_application")} />
      )}
    </>
  );
};

const DetailRow = ({ icon, label, value }) => (
  <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
    <div
      style={{
        width: 36,
        height: 36,
        borderRadius: 10,
        background: T.iconBox,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexShrink: 0,
        lineHeight: 0,
      }}
    >
      {icon}
    </div>
    <span style={{ color: "#FFFFFFA3", fontSize: 14, fontWeight: 400, flex: 1, lineHeight: "17px" }}>{label}</span>
    <span style={{ color: "#FFFFFF", fontWeight: 700, fontSize: 14, lineHeight: "17px" }}>{value}</span>
  </div>
);

const EmptyState = ({ title, subtitle }) => (
  <div
    style={{
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      minHeight: "55vh",
      textAlign: "center",
      padding: "24px 20px",
      border: "none",
      background: "transparent",
    }}
  >
    <div style={{ color: "#fff", fontSize: 18, fontWeight: 600, marginBottom: 8 }}>{title}</div>
    <div style={{ color: T.sub, fontSize: 14, fontWeight: 400 }}>{subtitle}</div>
  </div>
);

export default Accepted;
